module.exports = __webpack_public_path__ + "static/img/gywm_banner.a0d096a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introdution/gywm_banner.png
// module id = vWU3
// module chunks = 1